import { DecimalPipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import Map from 'ol/Map';
import ControlMousePosition from 'ol/control/MousePosition';
import { transform } from 'ol/proj';



@Component({
    selector: 'app-mouse-position',
    templateUrl: './mouse-position.component.html',
    styleUrls: ['./mouse-position.component.css'],
    providers: [DecimalPipe],
    standalone: false
})
export class MousePositionComponent implements OnInit {

  @Input() map: Map;
  @Input() positionTemplate: string;
  control: ControlMousePosition;

  constructor(
    private element: ElementRef,
    private decimalPipe: DecimalPipe
  ) {
  }

  ngOnInit() {
    this.control = new ControlMousePosition({
      className: 'mouseposition-control',
      coordinateFormat: (coordinates: number[]) =>
        this.numberCoordinates(coordinates, 4, this.positionTemplate),
      target: this.element.nativeElement,
    });
    this.map.addControl(this.control);
  }

  numberCoordinates(
    coordinates: number[],
    fractionDigits: number = 0,
    template?: string,
  ) {
    template = template || '{x} {y}';

    const [lon, lat] = transform(coordinates, 'EPSG:3857', 'EPSG:4326');

    const fmt = `1.${fractionDigits}-${fractionDigits}`;
    return template
      .replace('{x}', this.decimalPipe.transform(lat, fmt)!) // European style: lat first
      .replace('{y}', this.decimalPipe.transform(lon, fmt)!);
  }

}
